import React, { useState } from 'react';
import { InputAdornment, Tab, Tabs, TextField } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import SearchIcon from '@material-ui/icons/Search';
import ViewModuleIcon from '@material-ui/icons/ViewModule';
import { componentLabel } from '../../core/registry/componentLabels';
import { useComponentRegistry } from '../../core/registry';
import { COMPONENT_ICONS } from '../canvas/CanvasBuilder/constants';
import { useLocalizedMessage } from '../../../../util/useLocalizedMessage';
import styles from './Workspace.module.scss';

/** Shared registry-backed library; click is the keyboard/touch alternative to dragging. */
const BlockLibrary = ({ onAdd, disabled = false, draggable = false }) => {
  const t = useLocalizedMessage();
  const { registry } = useComponentRegistry();
  const [query, setQuery] = useState('');
  const [category, setCategory] = useState('block');
  const needle = query.toLowerCase().trim();
  const components = Object.entries(registry || {}).filter(([type, descriptor]) => (
    type !== 'columns' && descriptor && (needle || descriptor.category === category)
    && `${componentLabel(type, t)} ${type} ${descriptor.description || ''}`.toLowerCase().includes(needle)
  ));
  return <div className={styles.libraryContent}>
      <TextField fullWidth variant="outlined" size="small" value={query} onChange={event => setQuery(event.target.value)}
        placeholder={t('experience.design.searchLibrary')} inputProps={{ 'aria-label': t('experience.design.searchLibrary') }}
        InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon fontSize="small" /></InputAdornment> }} />
      <Tabs className={styles.libraryTabs} variant="fullWidth" value={category} onChange={(_, value) => setCategory(value)} indicatorColor="primary" aria-label={t('experience.design.blockTypes')}>
        <Tab value="block" label={t('experience.design.content')} /><Tab value="container" label={t('experience.design.layout')} />
      </Tabs>
      <div className={styles.libraryGrid}>
        {components.map(([type, descriptor]) => {
          const Icon = COMPONENT_ICONS[type] || ViewModuleIcon;
          const label = componentLabel(type, t);
          return <button key={type} type="button" className={styles.libraryItem} data-add-component={type}
            disabled={disabled} onClick={() => onAdd(type)} draggable={draggable && !disabled}
            onDragStart={event => {
              event.dataTransfer.setData('componentType', type);
              event.dataTransfer.effectAllowed = 'copy';
            }}>
            <span className={styles.libraryIcon}><Icon /></span>
            <span><strong>{label}</strong><small>{descriptor.description}</small></span>
            <AddIcon fontSize="small" />
          </button>;
        })}
      </div>
      {!components.length && <p className={styles.emptyText}>{t('experience.design.noMatchingBlocks')}</p>}
  </div>;
};
export default BlockLibrary;
